// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.transition-transform {
  transition: transform 0.3s ease-in-out;
}
.translate-y-full {
  transform: translateY(100%);
}
.translate-y-0 {
  transform: translateY(0);
}
`, "",{"version":3,"sources":["webpack://./src/css/customFabStyle.css"],"names":[],"mappings":"AAAA;EACE,sCAAsC;AACxC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,wBAAwB;AAC1B","sourcesContent":[".transition-transform {\n  transition: transform 0.3s ease-in-out;\n}\n.translate-y-full {\n  transform: translateY(100%);\n}\n.translate-y-0 {\n  transform: translateY(0);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
